'use client';
import { getUrlGtm } from '@/utils/gtmUtils';
import classNames from 'classnames';
import GloLayout from 'code-micro/common/GloLayoutA';
import { ContentServerProps } from 'code-micro/props/content';
import { isH5HandleClient } from 'eco-design-micro/utils-base/isH5Handle';
import getLocal from 'eco-design-reliance/getLocal';
import gtm from 'eco-design-reliance/gtm';
import EcoImgVideo from 'eco-design/base/eco-img-video';
import EcoLink from 'eco-design/base/eco-link';
import { useEffect, useState } from 'react';
import { Autoplay, Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import './index.scss';

export const SwiperArrow = (
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">
        <path
            d="M6.56019 12.5836L1.05065 7.07409C0.871663 6.8951 0.871663 6.6049 1.05065 6.42591L6.56019 0.916369"
            stroke="currentColor"
            strokeWidth="1.83333"
            strokeLinecap="round"
        />
    </svg>
);

export default function Content({ id, data = {}, initIndex = 0 }: ContentServerProps) {
    const { locale = 'us' } = getLocal();
    const { title, desc, list = [], isAutoplay, theme = 'black' } = data;
    const prefixCls = 'index-swiper-a1';

    const [isH5, setIsH5] = useState(false);
    useEffect(() => {
        setIsH5(isH5HandleClient());
    }, []);

    const handleGtmBtn = (text: string) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'banner_switch',
            position: `Homepage_Swiper_1_${text}`,
            button_name: text,

            __btn_id1: `twlb-swiper-${text}`,
            __btn_id2: `twlb-swiper-${text}`,
            __btn_type: 'common',
        });
    };

    return (
        <GloLayout className={`editor-index-swiper-a1 editor-index-swiper-a1-${theme}`} id={id} data={data}>
            {(title || desc) && (
                <div className={`index-swiper-a1-info `}>
                    <h2 className={`${prefixCls}-title`}>{title}</h2>
                    <p className={`${prefixCls}-desc`}>{desc}</p>
                </div>
            )}
            <Swiper
                className={`${prefixCls}-swiper ${isAutoplay ? '' : 'no-autoplay'}`}
                initialSlide={initIndex}
                loop
                autoplay={isAutoplay ? { delay: 3000, disableOnInteraction: false } : false}
                pagination={isH5 ? { clickable: true } : false}
                navigation={{
                    nextEl: `.${prefixCls}-control .swiper-button-next`,
                    prevEl: `.${prefixCls}-control .swiper-button-prev`,
                }}
                modules={[Navigation, Pagination, Autoplay]}
                spaceBetween={isH5 ? 24 : 12}
                centeredSlides
                speed={1000}
                slidesPerView="auto"
                key={isAutoplay ? 'autoplay-true' : 'autoplay-false'}
            >
                {list.map((item: any, index: number) => {
                    const { label, title: itemTitle, desc, theme = 'white', lHref, lBtnContent } = item;
                    const itemClasses = classNames({
                        [`${prefixCls}-item`]: true,
                        [`${prefixCls}-item-${index + 1}`]: true,
                        [`${prefixCls}-theme-${theme}`]: theme,
                    });
                    return (
                        <SwiperSlide className={itemClasses} key={index}>
                            <div className={`${prefixCls}-item-img`}>
                                <EcoImgVideo isVideo={item.isVideo} pc={item.pc} h5={item.h5} />
                            </div>
                            <div className={`${prefixCls}-item-msg`}>
                                <div className={`${prefixCls}-item-info`}>
                                    {label && <div className={`${prefixCls}-item-label`}>{label}</div>}
                                    {itemTitle && <div className={`${prefixCls}-item-title`}>{itemTitle}</div>}
                                    {desc && <div className={`${prefixCls}-item-desc`}>{desc}</div>}
                                </div>
                                {lBtnContent && (
                                    <EcoLink
                                        className={`${prefixCls}-item-btn GtmModuleData-btn-href twlb-item-${index}`}
                                        href={lHref}
                                        dataLayer={{
                                            ...getUrlGtm(lHref, locale, {
                                                list_name: title,
                                                button_name: lBtnContent,
                                                product_name: itemTitle,
                                            }),
                                            position: `Homepage_Swiper_1_${index + 1}_btn`,

                                            __btn_id1: `twlb-item-${index}`,
                                            __btn_id2: lHref,
                                            __btn_type: 'href',
                                        }}
                                    >
                                        {lBtnContent}
                                    </EcoLink>
                                )}
                            </div>
                        </SwiperSlide>
                    );
                })}
                <div className={`${prefixCls}-control`}>
                    <div
                        className={`swiper-button-prev GtmModuleData-btn-common twlb-swiper-Left`}
                        data-btn-id="twlb-swiper-Left"
                        onClick={() => handleGtmBtn('Left')}
                    >
                        {SwiperArrow}
                    </div>
                    <div
                        className={`swiper-button-next GtmModuleData-btn-common twlb-swiper-Right`}
                        data-btn-id="twlb-swiper-Right"
                        onClick={() => handleGtmBtn('Right')}
                    >
                        {SwiperArrow}
                    </div>
                </div>
            </Swiper>
        </GloLayout>
    );
}
